<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="DED"><span class="ePub-I">For Layla</span></p>
<p class="img"><img alt="image" height="136" src="images/pgiii.jpg" width="350"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4ef75170